module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/add_shopping_cart.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/add_shopping_cart.png
// module id = 1356
// module chunks = 418